import { postJson } from '../../../modules/ajax'
import { isLoading, setLoading, buildProductParams } from './product-selection-state'
import { handleProductSelectionResponse } from './response-handler'

export function changeProductSelection(clickedElement, stateElement) {
  if (isLoading(stateElement)) {
    return
  }

  setLoading(stateElement, true)

  const productParams = buildProductParams(stateElement, clickedElement)
  executeProductSelectionRequest(productParams, handleProductSelectionResponse, handleError)

  function handleError(xhr, status, error) {
    console.error('Product selection failed:', status, error, xhr.responseText)
    setLoading(stateElement, false)
  }
}

function executeProductSelectionRequest(params, successCallback, errorCallback) {
  postJson('/product_lines/change_selection', params, successCallback, errorCallback)
}
